import './PaymentLoading.css';

export default function PaymentLoading({ show, message = 'Processing your payment...' }) {
  if (!show) return null;

  return (
    <div className="payment-loading-overlay">
      <div className="payment-loading-card">
        <video autoPlay loop muted playsInline className="payment-loading-video">
          <source src="/payment-loading.mp4" type="video/mp4" />
        </video>
        <p className="payment-loading-text">{message}</p>
      </div>
    </div>
  );
}
